<template>
  <el-dialog class="info-dialog-all" :title="objOption.title" :visible.sync="visible" :width="objOption.width" :center="objOption.isCenter" @close="onClose" :close-on-click-modal="false">
    <div class="delete-dialog">
      <!-- <div class="tip1" >{{content}}</div> -->
      <div class="tip1">
        <!-- <slot name="content"> -->
        <div v-html="objOption.content" :style="objOption.isCenter ? 'text-align:center' : ''"></div>
        <!-- </slot> -->
      </div>
      <el-checkbox v-model="objOption.notice" v-if="objOption.showCheck"><span class="tip2">此次问卷编辑，不再提醒</span> </el-checkbox>

      <div v-if="objOption.showBtns">
        <div class="btns" v-if="objOption.normalBtnStyle">
          <el-button class="cancelBtn" v-if="objOption.cancelBtn" @click.stop="handleCancel">{{ objOption.cancelBtnText }}</el-button>
          <el-button class="submitBtn" type="primary" v-if="objOption.submitBtn" v-focus ref="ipt" @click.stop="handleSave">{{ objOption.confirmBtnText }}</el-button>
        </div>
        <div class="btns" v-else style="justify-content: space-between">
          <el-button class="textBtn" type="text" v-if="objOption.cancelBtn" @click.stop="handleCancel">{{ objOption.cancelBtnText }}</el-button>
          <el-button class="submitBtn" type="primary" v-if="objOption.submitBtn" v-focus ref="ipt" @click.stop="handleSave">{{ objOption.confirmBtnText }}</el-button>
        </div>
      </div>
      <slot name="btns" v-else> </slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'FrontQuestionnaireInfoDialogIndex',

  data() {
    return {
      visible: false,
      objOption: {
        content: '', // 内容
        title: '提示', // 标题
        cancelBtn: true, // 取消按钮是否显示
        submitBtn: true, // 确认按钮是否显示
        showCheck: false, // 是否显示单选框
        notice: false, // 单选框开关
        width: '400px', // 宽度
        cancelBtnText: '取消', // 取消按钮文案
        confirmBtnText: '确定', // 确定按钮文案
        isCenter: true, // 弹窗内容是否居中
        normalBtnStyle: true, // 普通按钮样式
        showBtns: true,
        // onClose(),
      },
    };
  },
  components: {},
  created() {
    console.log(this.objOption, 'objOption');
  },
  methods: {
    handleCancel() {
      this.$emit('on-cancel');
    },
    handleSave() {
      this.$emit('on-success');
    },
    onClose() {
      console.log('关闭');
      this.$emit('on-close');
    },
  },
};
</script>

<style lang="less">
.info-dialog-all {
  .el-dialog--center {
    box-shadow: none;
    overflow: hidden;
    border-radius: 15px;
  }
  .el-dialog__body,
  .el-dialog__title {
    color: #3b4664;
  }
  .tip1 {
    font-size: 16px;
    margin-bottom: 40px;
  }
  .tip2 {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #a8abb4;
  }
  .btns {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
    .cancelBtn {
      width: 140px;
      height: 35px;
      background: #ffffff;
      border: 1px solid #2378ff;
      border-radius: 2px;
      font-size: 16px;
      color: #2378ff !important;
      &:hover {
        background: #f2fbff;
      }
    }
    .submitBtn {
      width: 140px;
      height: 35px;
      background-color: #2378ff;
      font-size: 16px;
      border-radius: 2px;
      border: 1px solid #2378ff;
      &:hover {
        background: rgba(#2378ff, 0.8);
      }
    }
    .textBtn {
      font-size: 16px;
      color: #2378ff;
    }
  }
}
</style>
